export const pickleballRules = [
  {
    title: 'Court Dimensions',
    type: 'info',
    diagram: {
      label: 'Court Size',
      value: '20\' × 44\''
    },
    points: [
      'Same dimensions for singles and doubles play',
      'Net height: 36" at sidelines, 34" at center',
      'Identical to badminton doubles court'
    ],
    keyFact: 'The court is exactly the same size as a badminton doubles court!'
  },
  {
    title: 'The Kitchen (Non-Volley Zone)',
    type: 'dont',
    diagram: {
      label: 'Kitchen Distance',
      value: '7 feet'
    },
    points: [
      'No volleying while standing inside this zone',
      'Extends 7 feet from the net on both sides',
      'You CAN enter the kitchen - just can\'t volley there',
      'Momentum rule: stepping in after a volley is a fault'
    ],
    keyFact: 'The kitchen line itself is part of the kitchen - touching it during a volley is a fault!'
  },
  {
    title: 'Scoring System',
    type: 'info',
    diagram: {
      label: 'Points to Win',
      value: '11'
    },
    points: [
      'Only the serving team can score points',
      'Must win by 2 points',
      'Tournament games may be 15 or 21 points',
      'Score format: Server-Receiver-Server# (e.g., "5-4-2")'
    ],
    keyFact: 'Every game starts with the score "0-0-2" - only one player serves on the first service turn!'
  },
  {
    title: 'The Two-Bounce Rule',
    type: 'do',
    diagram: {
      label: 'Required Bounces',
      value: '2'
    },
    points: [
      'Ball MUST bounce once on each side after the serve',
      'Applies to both the serve and the return',
      'Prevents serve-and-volley advantage',
      'After two bounces, volleys are allowed'
    ],
    keyFact: 'This rule is what makes pickleball unique - it extends rallies and emphasizes strategy over power!'
  },
  {
    title: 'Serving Rules',
    type: 'do',
    diagram: {
      label: 'Serve Attempts',
      value: '1'
    },
    points: [
      'Must use underhand motion with upward arc',
      'Paddle contact below waist level',
      'Serve diagonally to opponent\'s service court',
      'Only ONE serve attempt (no second serves)',
      'Both feet must be behind the baseline'
    ],
    keyFact: 'Unlike tennis, there are no second serves in pickleball - make your serve count!'
  },
  {
    title: 'Common Faults to Avoid',
    type: 'dont',
    points: [
      'Volleying before the two required bounces',
      'Stepping in the kitchen during or after a volley',
      'Serve not clearing the kitchen or landing out',
      'Ball touching any part of your body or clothing'
    ],
    keyFact: 'Most beginner faults happen in the kitchen - always be aware of the line!'
  }
];

export const pickleballGoverningBodies = [
  {
    name: 'USA Pickleball (USAP)',
    description: 'National governing body for pickleball in the United States. Maintains official rules, sanctons tournaments, and operates through 1,800+ ambassadors nationwide.',
    website: 'https://usapickleball.org'
  },
  {
    name: 'International Pickleball Federation (IPF)',
    description: 'Global governing body promoting pickleball worldwide with over 80 member countries. Works toward Olympic sport recognition and organizes international championships.',
    website: 'https://theipf.org'
  }
];

export const pickleballTournaments = [
  {
    name: 'PPA Tour',
    description: 'Professional Pickleball Association tour featuring top players with nearly $3M in annual prize money. Events across US and internationally.',
    website: 'https://ppatour.com'
  },
  {
    name: 'APP Tour',
    description: 'Association of Pickleball Professionals - first USA Pickleball-sanctioned professional tour with majors and championship events.',
    website: 'https://www.theapp.global'
  },
  {
    name: 'Major League Pickleball (MLP)',
    description: '22 hometown teams competing in team format with innovative MLPlay™ scoring. Features DreamBreaker™ singles tiebreaker format.',
    website: 'https://majorleaguepickleball.co'
  },
  {
    name: 'US Open Pickleball Championships',
    description: 'Most prestigious tournament in the sport. Held annually in Naples, Florida with 55,000+ fans and 3,450+ players from around the world.',
    website: 'https://www.usopenpickleball.com'
  },
  {
    name: 'USA Pickleball National Championships',
    description: 'Pinnacle of amateur/competitive pickleball held in San Diego. Requires Golden Ticket qualification for priority registration.',
    website: 'https://usapickleballnationals.com'
  }
];

export const pickleballResources = [
  {
    name: 'USA Pickleball Tournament Calendar',
    website: 'https://usapickleball.org/events/'
  },
  {
    name: 'Pickleball Brackets',
    website: 'https://pickleballbrackets.com'
  },
  {
    name: 'Pickleball Tournaments',
    website: 'https://pickleballtournaments.com'
  }
];
